import { icValidator } from '@gov-nx/utils/common';

export const isValidIc = (value: string | undefined): value is string =>
	!!value && value.length > 2 && icValidator(value);
